<template>
  <div>
    <v-card v-if="$store.state.logged.status" class="mx-4">
      <v-dialog v-model="dialog" persistent max-width="600">
        <template v-slot:activator="{ on }">
          <div style="padding: 3rem 0" class="ma-4">
            <p class="text-center mb-4">
              {{ $t("suspendDescription") }}
            </p>
            <v-btn v-on="on" color="primary">
              {{ $t("suspendQuestion") }}
            </v-btn>
          </div>
        </template>
        <v-card class="ma-0">
          <v-card-title primary-title class="px-4">
            <div class="headline mb-0">{{ $t("accountSuspend") }}</div>

            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-title>

          <v-alert :value="true" type="warning" class="text-left mx-6 my-4">
            {{ $t("cantBeUndone") }}
          </v-alert>

          <v-card-text class="pb-0 pt-4">
            <!-- CALENDAR -->
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="computedDateFormatted"
                  outlined
                  :label="$t('date')"
                  prepend-icon="mdi-calendar"
                  readonly
                  hint="DD/MM/YYYY"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                @input="menu2 = false"
                :min="new Date().toISOString().substr(0, 10)"
                :max="maxDate"
              ></v-date-picker>
            </v-menu>
            <v-card-title class="text-h6">
              {{ $t("suspensionReason") }}
            </v-card-title>
            <div class="mx-4">
              <v-select
                v-model="selectedReason"
                :placeholder="$t('selectAReasonToSuspend')"
                outlined
                return-object
                :items="selectReasonItems"
                item-text="label"
                item-value="value"
                @change="reasonChanged"
              ></v-select>
              <v-textarea
                maxlength="300"
                v-if="showReasonTextarea"
                v-model="reason"
                class="px-2"
                auto-grow
                outlined
                rows="2"
                row-height="15"
                v-bind:placeholder="$t('suspensionReasonDescription')"
              />
            </div>
            <v-checkbox v-model="confirm" :label="$t('confirm')"></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <!-- <v-divider class="mr-2"></v-divider> -->
            <v-btn
              tabindex="8"
              block
              type="submit"
              class="primary darken-1"
              @click.prevent="suspendAccount"
              :disabled="!confirm || !selectedReason"
              >{{ $t("save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <v-card v-else class="mx-4">
      <v-alert class="text-center mx-4">
        {{ $t("areaForPlayersLogged") }}
      </v-alert>
    </v-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      date: "",
      menu2: false,
      maxDate: "",
      confirm: false,
      reason: "",
      showReasonTextarea: false,
      selectedReason: null,
      selectReasonItems: [],
    };
  },
  mounted() {
    this.selectReasonItems = [
      {
        label: this.$t("addiction"),
        value: this.$t("addiction"),
      },
      {
        label: this.$t("noTime"),
        value: this.$t("noTime"),
      },
      {
        label: this.$t("instatisfactionOperator"),
        value: this.$t("instatisfactionOperator"),
      },
      {
        label: this.$t("instatisfactionBonus"),
        value: this.$t("instatisfactionBonus"),
      },
      {
        label: this.$t("other"),
        value: "Outro",
      },
      {
        label: this.$t("dontWantToSay"),
        value: this.$t("dontWantToSay"),
      },
    ];

    this.date = new Date().toISOString().substr(0, 10);
    this.maxDate = new Date(new Date(this.date).setHours(23, 59, 59))
      .add(41)
      .toISOString();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  methods: {
    reasonChanged() {
      if (this.selectedReason.value == "Outro") {
        this.reason = "";
        this.showReasonTextarea = true;
      } else {
        this.reason = this.selectedReason.value;
        this.showReasonTextarea = false;
      }
    },
    suspendAccount() {
      const data = {
        suspend: this.confirm ? 1 : 0,
        limit_suspension: `${this.date} 00:00:00`,
        reason: this.reason,
        domain: this.$domain(),
      };
      this.$axios
        .post("/player/user/disableAccount", this.$formdata(data))
        .then((res) => {
          this.$store.commit("setNotification", {
            msg: res.data.messages,
            color: "green",
          });
          this.$logout();
        })
        .catch((e) => {
          this.$store.commit("setNotification", {
            msg: e.response.data.messages.error,
            color: "warning",
          });
        });
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
<style scoped>
.v-card {
  min-height: 300px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 0.5rem;
}
</style>
